import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CircCommonModule } from "../common";
import { KendoModule } from "../kendo/kendo.module";
import { AdminViewComponent } from "../user/components/admin-view.component";
import { AdminGridComponent } from "./components/admin-grid.component";
import { AdminEditUserRoleComponent } from "./role/admin-edit-user-role";
import { AdminRoleComponent } from "./role/admin-role";
import { UserFacade } from "./services/user.facade";
import { UserEffects } from "./state/user.effects";
import { userReducer } from "./state/user.reducer";

@NgModule({
  declarations: [
    AdminViewComponent,
    AdminGridComponent,
    AdminEditUserRoleComponent,
    AdminRoleComponent
  ],
  imports: [
    CommonModule, //https://stackoverflow.com/questions/39625321/the-pipe-async-could-not-be-found - UserFacade use
    StoreModule.forFeature("user", userReducer),
    KendoModule,
    CircCommonModule,
    EffectsModule.forFeature([UserEffects])
  ],
  providers: [UserFacade]
})
export class UserModule {}
